import React, { useEffect } from 'react';
import './Funding.css';

const Funding = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const methods = [
    { icon: '💳', name: 'Credit/Debit Cards', fee: '$0', time: 'Instant', min: '$50' },
    { icon: '🏦', name: 'Bank Transfer', fee: '$0', time: '1-3 days', min: '$200' },
    { icon: '⚡', name: 'E-Wallets', fee: '$0', time: 'Instant', min: '$50' },
    { icon: '💎', name: 'Cryptocurrency', fee: 'Network fee', time: '10-60 min', min: '$100' },
    { icon: '📱', name: 'Mobile Payment', fee: '$0', time: 'Instant', min: '$50' }
  ];

  return (
    <div className="page-container">
      <div className="container">
        <button className="back-button" onClick={() => window.history.back()}>
          <span>←</span><span>Back to Home</span>
        </button>

        <h1>Funding Your Account</h1>
        <p className="subtitle">Fast, secure, and convenient deposit options. Fund your account instantly with zero fees.</p>

        <div className="payment-methods">
          {methods.map((method, index) => (
            <div key={index} className="method-card">
              <div className="method-icon">{method.icon}</div>
              <h3>{method.name}</h3>
              <div className="method-details"><strong>Fee:</strong> {method.fee}</div>
              <div className="method-details"><strong>Time:</strong> {method.time}</div>
              <div className="method-details"><strong>Min:</strong> {method.min}</div>
            </div>
          ))}
        </div>

        <div className="section">
          <h2>How to Deposit</h2>
          <ol className="deposit-steps">
            <li>Log in to your HijaAsset account</li>
            <li>Navigate to "Deposit" section</li>
            <li>Select your preferred payment method</li>
            <li>Enter the deposit amount</li>
            <li>Complete the payment</li>
            <li>Funds appear instantly</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default Funding;